var _g, _path, _g2, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReducingMarketRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24786_52360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4772 29H11.4545L7.13627 33H1.09082V48H47.7272V7L40.8181 11L36.0681 9.5L30.8863 16L23.1135 24H18.7954L14.4772 29Z",
    fill: "url(#paint0_linear_24786_52360)",
    fillOpacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 8L40.8182 10.9752L36.0682 9.4876L30.8864 15.9339L23.1136 23.8678H18.7955L14.4773 28.8264H11.4545L8 32",
    stroke: "#FF0400",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_24786_52360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5279 47.7639L34 54L46.4721 47.7639C49.86 46.07 52 42.6074 52 38.8197V17.5556C52 16.6406 51.3823 15.8469 50.4863 15.6615C47.7294 15.0911 41.4784 14 34 14C26.5216 14 20.2706 15.0911 17.5137 15.6615C16.6177 15.8469 16 16.6406 16 17.5556V38.8197C16 42.6074 18.14 46.07 21.5279 47.7639Z",
    fill: "url(#paint1_linear_24786_52360)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5279 47.7639L34 54L46.4721 47.7639C49.86 46.07 52 42.6074 52 38.8197V17.5556C52 16.6406 51.3823 15.8469 50.4863 15.6615C47.7294 15.0911 41.4784 14 34 14C26.5216 14 20.2706 15.0911 17.5137 15.6615C16.6177 15.8469 16 16.6406 16 17.5556V38.8197C16 42.6074 18.14 46.07 21.5279 47.7639Z",
    fill: "url(#paint2_radial_24786_52360)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 53.441L21.7515 47.3167C18.533 45.7075 16.5 42.418 16.5 38.8197V17.5556C16.5 16.8665 16.962 16.2862 17.615 16.1511C20.3518 15.5849 26.5669 14.5 34 14.5C41.4331 14.5 47.6482 15.5849 50.385 16.1511C51.038 16.2862 51.5 16.8665 51.5 17.5556V38.8197C51.5 42.418 49.467 45.7075 46.2485 47.3167L34 53.441Z",
    stroke: "url(#paint3_radial_24786_52360)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 53.441L21.7515 47.3167C18.533 45.7075 16.5 42.418 16.5 38.8197V17.5556C16.5 16.8665 16.962 16.2862 17.615 16.1511C20.3518 15.5849 26.5669 14.5 34 14.5C41.4331 14.5 47.6482 15.5849 50.385 16.1511C51.038 16.2862 51.5 16.8665 51.5 17.5556V38.8197C51.5 42.418 49.467 45.7075 46.2485 47.3167L34 53.441Z",
    stroke: "url(#paint4_radial_24786_52360)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7071 31.2071L34 34.5L41.7929 26.7071C42.1834 26.3166 42.8166 26.3166 43.2071 26.7071L44.777 28.277C45.1737 28.6737 45.1665 29.319 44.7611 29.7068L34.6811 39.3486C34.2986 39.7144 33.6972 39.7189 33.3094 39.3587L27.7604 34.2061C27.3451 33.8204 27.333 33.167 27.7338 32.7662L29.2929 31.2071C29.6834 30.8166 30.3166 30.8166 30.7071 31.2071Z",
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7071 30.2071L33 33.5L40.7929 25.7071C41.1834 25.3166 41.8166 25.3166 42.2071 25.7071L43.777 27.277C44.1737 27.6737 44.1665 28.319 43.7611 28.7068L33.6811 38.3486C33.2986 38.7144 32.6972 38.7189 32.3094 38.3587L26.7604 33.2061C26.3451 32.8204 26.333 32.167 26.7338 31.7662L28.2929 30.2071C28.6834 29.8166 29.3166 29.8166 29.7071 30.2071Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_24786_52360",
    x: 10,
    y: 8,
    width: 48,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_24786_52360"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_24786_52360",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24786_52360",
    x1: 24.409,
    y1: 9,
    x2: 24.409,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24786_52360",
    x1: 17.125,
    y1: 15,
    x2: 37.4304,
    y2: 51.0688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_24786_52360",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.125 15) scale(33.75 38)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_24786_52360",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.25 29.5) rotate(31.3633) scale(23.0564 21.9692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_24786_52360",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.25 13) rotate(128.22) scale(12.7285 13.1692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24786_52360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 44,
    fill: "white",
    transform: "translate(8 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReducingMarketRisk);
export default __webpack_public_path__ + "static/media/reducingMarketRisk.71e455ccd2b79aba2aea7180d34ad367.svg";
export { ForwardRef as ReactComponent };